import React from 'react';

const Stats = () => {
  return (
    <>
      <section className="bgcolor text-white py-10">
        <div className="gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-[80%] xl:w-11/12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y sm:divide-y-0 sm:divide-x divide-[#FFFFFF]/30">
            <div className="flex items-start space-x-4 p-6">
              <img src="/img/assets/home/global-presence.svg" alt="global-presence" className="w-16 h-16 textwhite" />
              <div>
                <p className="text-6xl">5+</p>
                <p className="text-sm mt-1 text-white/80">Countries</p>
              </div>
            </div>
            <div className="flex items-start space-x-4 p-6">
              <img src="/img/assets/home/leadership-experience.svg" alt="leadership-experience" className="w-16 h-16 textwhite" />
              <div>
                <p className="text-6xl">20+</p>
                <p className="text-sm mt-1 text-white/80">Experience</p>
              </div>
            </div>
            <div className="flex items-start space-x-4 p-6">
              <img src="/img/assets/home/senior-leaders-placed.svg" alt="senior-leaders-placed" className="w-16 h-16 textwhite" />
              <div>
                <p className="text-6xl">100+</p>
                <p className="text-sm mt-1 text-white/80">Leaders Placed</p>
              </div>
            </div>
            <div className="flex items-start space-x-4 p-6">
              <img src="/img/assets/home/industries-served.svg" alt="industries-served" className="w-16 h-16 textwhite" />
              <div>
                <p className="text-6xl">25+</p>
                <p className="text-sm mt-1 text-white/80">Industries Served</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>

  );
};

export default Stats;